import Create from "./Create";
import Edit from "./Edit";
import { EmailThemeIcon } from "../icons";
import List from "./List";

export default {
  options: {
    group: "admin",
    accessible: ({ user }) =>
      user.role === "admin" &&
      user.permissions.indexOf("email-theme/list") !== -1,
  },
  icon: EmailThemeIcon,
  list: List,
  create: Create,
  edit: Edit,
};
